// 页面中的 System 指的是 Device
export const device = {
  firmwareUpgrade: "Firmware Upgrade",
  upgradeFirmware: "Upgrade Firmware",
  currentFirmwareVersion: "Current Firmware Version: v{0}",
  releaseNotes: "Release Notes:",
  foundNewOTAPackage: "New firmware available: v{0}",
  settingsWillAppliedToAllDevices:
    "The settings will be applied to all systems.",
  upgradeYourDevicesToVersion: "Upgrade your systems to version: {0}?",
  newVersionAvailable: "New Firmware Available",
  firmwareVersion: "Firmware Version: v{0}",
  upgradeNow: "Upgrade Now",
  upgrade: "Upgrade",
  updateDeviceSettings: "Update System Settings",
  M3502PDName: "M350 - 2PD | Mobile360 M350 - 2PD + DSS",
  M3503PDName: "M350 - 3PD | Mobile360 M350 - 3PD",
  M350C100Name: "C100 | Mobile360 C100 AI Camera",
  globalSettings: "Global",
  wouldUpdateToVehicleTips1:
    "Select from the vehicles listed below to update with the new settings.",
  wouldUpdateToVehicleTips2:
    "(Unchecked vehicles will keep their current settings and can be synced at a later time on their respective vehicle pages)",
  versionHistory: "Version History",
  applyToVehicle: "Apply To Vehicle",
};
